module.exports = __webpack_public_path__ + "static/media/18.de8f5123.svg";